export const notificationconfig = {
    state: {
        noti_timestamp: localStorage.getItem('notification_timestamp'),
        noti_last_timestamp: "20210411_1349",
        noti_msg:{
            message: 'แจ้งการเปลี่ยนแปลงราคาทอง',
            description:'ช่องทางการชำระเงินผ่าน truewallet มีการเปลี่ยนแปลงอัตราราคา กรุณาตรวจสอบก่อนทำรายการ',
            duration: 6
        },
        noti_is_enable: false
    },
    getters: {
        GET_NOTI_TIMESTAMP(state) {
            return state.noti_timestamp
        },
        GET_LAST_NOTI_TIMESTAMP(state) {
            return state.noti_last_timestamp
        },
        GET_NOTI_MSG(state){
            return state.noti_msg
        },
        GET_NOTI_IS_ENABLE(state){
            return state.noti_is_enable
        }
    },
    mutations:{
        SET_NOTI_TIMESTAMP(){
            this.state.noti_timestamp = "20210411_1349"
            localStorage.setItem('notification_timestamp', '20210411_1349')
        }
    },
    actions: {
        SET_NOTI_TIMESTAMP({ commit }){
            commit('SET_NOTI_TIMESTAMP')
        }
    }
}